The page of events and their corresponding cursors.
